define('components/AdFreeLoginNavLink',[
    "jquery",
    "admiral",
    "logging"
], function ($, adm, logging) {
    "use strict";

    var _ModuleName = "Admiral Login Nav Link";

    function AdFreeLoginNavLink(scope) {
        if (adm.isEnabled()) {
            adm.checkUserSubscribed(function () {
                ;
            }, function () {
                $('a', scope).click(function (e) {
                    // prevent default anchor actions
                    e.stopPropagation && e.stopPropagation();
                    e.preventDefault && e.preventDefault();

                    // show admiral ad-free login
                    adm.showUserLogin();
                });

                // show link
                $(scope).show();
            });
        }
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new AdFreeLoginNavLink(args.scope);
        }
    }
});


